import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseCliScriptFromApi from '../../AbstractObjects/GatewayPlan/InnerPages/BaseCliScriptFromApi';

const pageSchema = PlanGetSchema.pages.cliScriptFromApi;
const pageId = pageSchema.pageId;

function PlanCliScriptFromApi({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseCliScriptFromApi
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanCliScriptFromApi;